export enum NotificationActionType {
  GET_ALL_FAILURE = '@@notification/GET_ALL_FAILURE',
  GET_ALL_REQUEST = '@@notification/GET_ALL_REQUEST',
  GET_ALL_SUCCESS = '@@notification/GET_ALL_SUCCESS',

  SET_FILTER = '@@notification/SET_FILTER',
  TOGGLE_DRAWER = '@@notification/TOGGLE_DRAWER',

  UPDATE_READ_FAILURE = '@@notification/UPDATE_READ_FAILURE',
  UPDATE_READ_REQUEST = '@@notification/UPDATE_READ_REQUEST',
  UPDATE_READ_SUCCESS = '@@notification/UPDATE_READ_SUCCESS',

  WATCH_START = '@@notification/WATCH_START',
  WATCH_STOP = '@@notification/WATCH_STOP',
}
